export default {
  detail: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500050A","详情") /* "详情" */,
  effect: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500050B","整单生效") /* "整单生效" */,
  unshelve: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500050C","下架商品") /* "下架商品" */,
  delContent: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500050D","确定删除？") /* "确定删除？" */,
  unshelveContent: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500050E","确定让该商品下架？") /* "确定让该商品下架？" */,
  enableContent: lang.templateByUuid("UID:P_UDHWN_17DD50DE0500050F","确定执行整单生效？") /* "确定执行整单生效？" */,
  switchSaleOrgTips: lang.templateByUuid("UID:P_UDHWN_17DD50DE05000510","是否要切换组织，切换组织将重置表格中的信息？") /* "是否要切换组织，切换组织将重置表格中的信息？" */
};
